import {
    Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChange, Directive, Provider, forwardRef,
    DoCheck, ChangeDetectionStrategy, ChangeDetectorRef, Injectable,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, Validators, NgForm, ControlContainer } from '@angular/forms';
import { BaseWidgetComponent } from '../base-widget.component';
import { ErrorStateMatcher } from '@angular/material/core';

const noop = () => { };
export const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DropdownComponent),
    multi: true
};

@Component({
    selector: 'dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    providers: [CUSTOM_VALUE_ACCESSOR],
    changeDetection: ChangeDetectionStrategy.OnPush,
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class DropdownComponent extends BaseWidgetComponent implements OnInit, OnChanges, ControlValueAccessor {
    private innerValue: any = null/*undefined*/;
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;
    writeValue(obj: any): void { if (obj !== this.innerValue) this.innerValue = obj; }
    registerOnChange(fn: any): void { this.onChangeCallback = fn; }
    registerOnTouched(fn: any): void { this.onTouchedCallback = fn; }
    setDisabledState?(isDisabled: boolean): void { }
    get value(): any { return this.innerValue; };
    set value(obj: any) {
        if (obj !== this.innerValue) {
            this.innerValue = obj;
            this.onChangeCallback(obj);
        }
    }

    @Input('id') id: number | string;
    @Input('disabled') disabled: boolean = false;
    @Input('required') required: boolean = false;
    @Input('placeholder') placeholder: string;
    @Input('options') options: IDropdownSelectOption[] | string[] | number[] = [];
    @Input('form') form: NgForm;
    @Input('showError') showError: boolean = true;
    @Input('isSelectOption') isSelectOption: boolean = true;
    @Input('requiredMessage') requiredMessage: string;
    @Input('preSelect') preSelect: boolean = true;
    @Input('hidden') hidden: boolean = false;
    @Output('onChange') onChange: EventEmitter<IDropdownSelectChangeEvent> = new EventEmitter<IDropdownSelectChangeEvent>();
    @Output('onClick') onClick: EventEmitter<IDropdownSelectChangeEvent> = new EventEmitter<IDropdownSelectChangeEvent>();
    private oldValue: any = null/*undefined*/;
    private defaultValue: any = null/*undefined*/;

    constructor(private changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) { // model reference changes
        for (let propName in changes) {
            if (propName === 'options') {
                //this.value = null/*undefined*/; // reset value if options changes
                //this.oldOptions = this.options;
                if (this.options && this.options.length == 1 && this.preSelect) {
                    if (this.isSelectOption) {
                        this.value = (<IDropdownSelectOption>this.options[0]).Id; // this will trigger (selectionChange) event
                        //this.onSelectOptionsChange(undefined);
                    }
                    else {
                        this.value = (<string | number>this.options[0]);
                        //this.onRegularOptionsChange(undefined);
                    }
                } else {
                    this.value = null;
                }
            }
        }
    }

    ngDoCheck() { // property of the model changes
        //if (this.oldValue !== this.value) {
        //  this.changeDetectorRef.markForCheck();
        //  this.oldValue = this.value;
        //}

        //if ((this.value !== null && this.value !== undefined) && (this.defaultValue !== this.value)) {
        //  // if during initialize value was default assigned
        //  if ((this.defaultValue === null || this.defaultValue === undefined) && (this.value !== null && this.value !== undefined)) {
        //    this.defaultValue = this.value;
        //    this.changeDetectorRef.markForCheck();
        //    if (this.isSelectOption)
        //      this.onSelectOptionsChange(undefined);
        //    else
        //      this.onRegularOptionsChange(undefined);
        //  }
        //}

        if ((this.oldValue !== this.value) && (this.options != undefined && this.options != null/* && this.options.length > 0*/)) {
            if (this.value === undefined) this.value = null;
            if (this.oldValue === this.value) return;
            this.oldValue = this.value;
            if (this.isSelectOption)
                this.onSelectOptionsChange(null/*undefined*/, true);
            else
                this.onRegularOptionsChange(null/*undefined*/, true);
        }
    }

    ngAfterViewInit() {
        //if (this.value) // if default value setup
        //  this.onSelectOptionsChange(null);
        //if (this.required && (this.value === null && this.value === undefined))
        //  this.value = -1;
    }

    onSelectOptionsChange($event, changeTriggered: boolean = false) {
        if (!changeTriggered) return;
        if (this.value && this.value > 0) {
            let option: IDropdownSelectOption = (<IDropdownSelectOption[]>(this.options)).filter(x => x.Id == this.value)[0];
            this.onChange.emit({ Id: this.value, Value: <IDropdownSelectOption>option, Options: this.options });
        }
        else {
            this.onChange.emit({ Id: this.value, Value: null/*undefined*/, Options: this.options });
        }
    }

    getErrorMessage(): string {
        return this.form.controls[this.id].hasError('required') ? (this.placeholder + ' is required.') : 'Unknown error.';
    }

    isInvalid(): boolean {
        if (this.showError && this.form && this.form.controls[this.id] && this.form.controls[this.id].invalid)
            return true;
        else
            return false;
    }

    onRegularOptionsChange($event, changeTriggered: boolean = false) {
        if (!changeTriggered) return;
        if (this.value) {
            let option: string | number;
            if (isNaN(this.value)) {
                option = (<string[]>this.options).filter(x => x == this.value)[0];
                this.onChange.emit({ Id: this.value, Value: <string>option, Options: this.options });
            }
            else {
                option = (<number[]>this.options).filter(x => x == this.value)[0];
                this.onChange.emit({ Id: this.value, Value: <number>option, Options: this.options });
            }
        }
        else {
            if (isNaN(this.value))
                this.onChange.emit({ Id: this.value, Value: null/*undefined*/, Options: this.options });
            else
                this.onChange.emit({ Id: this.value, Value: null/*undefined*/, Options: this.options });
        }
    }

    onSelectionOptionsClick($event) {
        if (this.value && this.value > 0) {
            let option: IDropdownSelectOption = (<IDropdownSelectOption[]>(this.options)).filter(x => x.Id == this.value)[0];
            this.onClick.emit({ Id: this.value, Value: <IDropdownSelectOption>option, Options: this.options });
        }
        else {
            this.onClick.emit({ Id: this.value, Value: null, Options: this.options });
        }
    }

    onRegularOptionsClick($event) {
        if (this.value) {
            let option: string | number;
            if (isNaN(this.value)) {
                option = (<string[]>this.options).filter(x => x == this.value)[0];
                this.onClick.emit({ Id: this.value, Value: <string>option, Options: this.options });
            }
            else {
                option = (<number[]>this.options).filter(x => x == this.value)[0];
                this.onClick.emit({ Id: this.value, Value: <number>option, Options: this.options });
            }
        }
        else {
            if (isNaN(this.value))
                this.onClick.emit({ Id: this.value, Value: null, Options: this.options });
            else
                this.onClick.emit({ Id: this.value, Value: null, Options: this.options });
        }
    }
}

export interface IDropdownSelectOption {
    Id: number,
    Name: string
}

export interface IDropdownSelectChangeEvent {
    Id: number | string;
    Value: IDropdownSelectOption | string | number;
    Options: IDropdownSelectOption[] | string[] | number[];
}

export interface IRequired {
    Required: boolean;
    Message: string;
}


@Injectable()
export class DropdownService {
    public reset(value: number | string, options: IDropdownSelectOption[] | string[] | number[], isSelectOption: boolean = true) {
        if (options && options.length == 1) {
            if (isSelectOption) {
                value = (<IDropdownSelectOption>options[0]).Id;
            }
            else {
                value = (<string | number>options[0]);
            }
        }
        else
            value = null;// undefined;
    }
}




// WEBPACK FOOTER //
// ./src/app/widgets/dropdown/dropdown.component.ts